import React from 'react';
import { useParams } from 'react-router-dom';
import SigtiRange from './SigtiRange';

const SigtiRangeRoute: React.FC = () => {
  const { symbol } = useParams();
  return <SigtiRange symbol={symbol || ''} />;
};

export default SigtiRangeRoute;